import { createClient } from '@supabase/supabase-js';

// Create a single supabase client for interacting with your database
const supabase = createClient('https://ozyyjzhyimltxvladcbv.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im96eXlqemh5aW1sdHh2bGFkY2J2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg3MTQwMzgsImV4cCI6MjA1NDI5MDAzOH0.nFS-gW6niZ57_iRzxlKlt_VNF8IqGrf6U2IaRJodTGc');


document.getElementById("loginBtn").addEventListener("click", () => {
    signIn();
});

document.getElementById("signupBtn").addEventListener("click", () => {
    signUp();
});

document.getElementById("logoutBtn").addEventListener("click", () => {
    signOut();
});

document.getElementById("helpBtn").addEventListener("click", () => {
  sendHelpRequest();
});



async function signUp() {
    const email = document.getElementById("email").value;
    const password = document.getElementById("password").value;

    let { error } = await supabase.auth.signUp({ email, password });

    if (error) {
      if (error.message === "Anonymous sign-ins are disabled") {
        alert("Please enter an email and password to sign up");
      } else {
        alert(error.message);
      }
    } else {
		alert("Check your email to verify your account.");
    }
}

// Sign In Function
async function signIn() {
    const email = document.getElementById("email").value;
    const password = document.getElementById("password").value;

    let { data, error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
		alert(error.message);
    } else {
    //alert("Login successful!");
		hideLoginDialog();
    }
}

// Sign Out Function
async function signOut() {
    let { error } = await supabase.auth.signOut();

    if (error) {
  		alert(error.message);
    } else {
		  showLoginDialog();
    } 
}

async function sendHelpRequest() {
  const userEmail = document.getElementById("email").value || "Unknown User";

  if (userEmail === "Unknown User") {
    alert ("Please enter your email below and click the orange \"Need Help?\" button");
    return;
  }
 
  const issue = prompt("Describe your issue:");

  if (!issue) {
      alert("Please enter a message.");
      return;
  }

  try {
      const response = await fetch('https://ozyyjzhyimltxvladcbv.supabase.co/functions/v1/send-help-email', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              // Only include Authorization if needed (like if you require JWT authentication)
              // 'Authorization': `Bearer ${your_supabase_jwt}`
          },
          body: JSON.stringify({
              user_email: userEmail,
              issue: issue
          })
      });

      if (response.ok) {
          const data = await response.json();
          alert('Email sent successfully! FoundDigitalMaps Admin will contact you soon!');
          console.log('Email sent successfully:', data);
      } else {
          const errorData = await response.json();
          alert('Error sending email: ' + errorData.error);
          console.error('Error sending email:', errorData);
      }
  } catch (error) {
      alert('Network error: ' + error.message);
      console.error('Network error:', error);
  }
}

// Hide Login Dialog and Remove Blur
function hideLoginDialog() {
    document.getElementById("loginDialog").style.display = "none";
    document.getElementById("logoutBtn").style.display = "block";
    document.getElementById("mainContainer").classList.remove("blurcontainer");
}

// Show Login Dialog and Blur Background
function showLoginDialog() {
    document.getElementById("loginDialog").style.display = "flex";
    document.getElementById("logoutBtn").style.display = "none";
    document.getElementById("mainContainer").classList.add("blurcontainer");
}

// Check Auth State on Load
async function checkAuth() {
    const { data: { session } } = await supabase.auth.getSession();
    if (session) {
		hideLoginDialog();
    } else {
		showLoginDialog();
    }
}

checkAuth();
